import { useIntl } from "react-intl";

import FeatureGates from "@atlassian/feature-gate-js-client";
import UFOSegment from "@atlassian/wac-ufo-segment";

import BannerAlert from "@/components/wpl/banner-alert/src/index";
import { useLocalizedHref } from "@/libraries/web-framework";
import GlobalFooterPattern from "@/patterns/global-footer/src/index";
import GlobalNavigation from "@/patterns/global-nav/src/index";

import {
    Hero,
    Carousel,
    SocialProof,
    Cards,
    Careers,
    LiftedBanner
} from "./sections";

export const HomePageTemplate = () => {
    const intl = useIntl();
    const gate: boolean = FeatureGates.checkGate("gwp-745-unleash-butter-bar");
    const serverBannerMessages = {
        identifier: "HomePage.banner-alert.server-support-end",
        text: intl.formatMessage({
            id: "HomePage.banner-alert.text",
            defaultMessage:
                "Support for Server products ends Feb. 15, 2024. Migrate to stay supported."
        }),
        linkText: intl.formatMessage({
            id: "HomePage.banner-alert.link-text",
            defaultMessage: "Act now"
        }),
        linkUrl: useLocalizedHref("/migration/assess/journey-to-cloud")
    };

    const unleashBannerMessages = {
        identifier: "HomePage.banner-alert.atlassian-presents-unleash",
        text: intl.formatMessage({
            id: "HomePage.banner-alert.atlassian-presents-unleash",
            defaultMessage:
                "Watch Atlassian Presents: Unleash on demand! Get tips for managing complexity at scale and staying in the flow."
        }),
        linkText: intl.formatMessage({
            id: "HomePage.banner-alert.atlassian-presents-unleash.link-text",
            defaultMessage: "Watch now"
        }),
        linkUrl:
            "https://events.atlassian.com/unleash/in-person?ref=Unleash&utm_source=marketing&utm_campaign=acquisitionwebliftedbar&utm_medium=web"
    };

    return (
        <UFOSegment name="home-page">
            <div>
                <GlobalNavigation showTryNow={true} productKey={"home"} />
                {gate ? (
                    <BannerAlert
                        identifier={unleashBannerMessages.identifier}
                        text={unleashBannerMessages.text}
                        linkUrl={unleashBannerMessages.linkUrl}
                        linkText={unleashBannerMessages.linkText}
                    />
                ) : (
                    <BannerAlert
                        identifier={serverBannerMessages.identifier}
                        text={serverBannerMessages.text}
                        linkUrl={serverBannerMessages.linkUrl}
                        linkText={serverBannerMessages.linkText}
                    />
                )}

                <Hero />
                <LiftedBanner />
                <Carousel />
                <SocialProof />
                <Cards />
                <Careers />
                <GlobalFooterPattern />
            </div>
        </UFOSegment>
    );
};
